import curveMobile1x from './fp-bckg-mobile@1x.png';
import curveMobile2x from './fp-bckg-mobile@2x.png';
import curveTablet1x from './fp-bckg-tablet@1x.png';
import curveTablet2x from './fp-bckg-tablet@2x.png';
import curveDesktop1x from './fp-bckg-desktop@1x.png';
import curveDesktop2x from './fp-bckg-desktop@2x.png';

export const bgImgs = {
  curveMobile1x,
  curveMobile2x,
  curveTablet1x,
  curveTablet2x,
  curveDesktop1x,
  curveDesktop2x,
};
